// export const CLIENT_ID = "AZNso-03pTFdM0hk7gPuWvkNGgUggZGKqK_VMdIgDZa664S8MI3SyjoiprbF2BMO4Zym129OLzI--VU-"
// export const APP_SECRET = "EGfGiXyTTnhwtGxLfuBcEloPgShcMJnDnaphBXFOAyrTnUjzQtr94MH6YgNeQDLkgQRrcIctf3EYzJsT"

export const CLIENT_ID = "Ady5P6yaIfTamsaPTf_qJKUpytLuSOFtX0PaKYBgSYHJRzbgUDtmwH4YknG2JETZ2Tc_50tQtRoDykLO"
export const APP_SECRET = "ECr_GAzfzT4_hVIc_HwC-U47qT2av4pOdmthbCDYNYRHvDxzh9Iyl_CpX4RnXFWqPVV-8862GRZKMHw9"